import { Box } from "@twilio-paste/core/box";
import { styled } from "@twilio-paste/styling-library";

export const AnchorContainer = styled(Box)`
    scroll-margin-top: 80px;
`;
